import React from "react";
import Grid from "@mui/material/Grid2";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { AboutUsLine } from "../../svgImage";
import styles from "./LandingPage.module.css";
import "react-multi-carousel/lib/styles.css";
import { ManualImageCarousel } from "../custom/Carousel";
import burntCheesecake from "../../assets/umami/burntCheesecake.jpg";
import hummusBowl from "../../assets/umami/hummusBowl.jpg";
import labnehBalls from "../../assets/umami/labnehBalls.png";
import mediterranean from "../../assets/umami/mediterranean.jpg";
import nachosWithGuac from "../../assets/umami/nachosWithGuac.jpg";
import toast from "../../assets/umami/toast.jpg";

const Umami = () => {
  const isMobile = useMediaQuery("(max-width:468px)");
  const images = [
    {
      src: mediterranean,
      name: "Mediterranean Platter",
    },

    {
      src: labnehBalls,
      name: "Labneh Balls",
    },
    {
      src: toast,
      name: "Avocado Toast",
    },
    {
      src: nachosWithGuac,
      name: "Nachos with Guac",
    },
    {
      src: hummusBowl,
      name: "Mediterranean Hummus Bowl",
    },
  ];
  return (
    <Box
      maxWidth="940px"
      width="100%"
      margin="auto"
      display="flex"
      flexDirection={"column"}
      mt={"100px"}
      gap={{ xs: 4, md: 3 }}
      px={{ xs: 2, sm: 3, md: 0 }}
    >
      {/* LEFT SECTION */}
      <Box display={"flex"} flexDirection={"column"}>
        <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
          <AboutUsLine width={isMobile ? "60px" : "80px"} />
          <Typography
            className={styles.Aboutustext}
            paddingLeft={1}
            fontSize={{ xs: "18px", sm: "20px", md: "22px" }}
          >
            Umami
          </Typography>
        </Box>

        <Typography
          className={styles.AboutUsShortDiscription}
          mt="20px"
          fontSize={{ xs: "14px", sm: "15px", md: "16px" }}
        >
          Symphony of flavors in every bite.
        </Typography>
      </Box>

      {/* RIGHT SECTION – CAROUSEL */}
      <Box
        width="100vw"
        mt="24px"
        sx={{
          position: "relative",
          left: "50%",
          right: "50%",
          marginLeft: "-50vw",
          marginRight: "-50vw",
        }}
      >
        <ManualImageCarousel
          cards={images}
          paddingLeft="calc((100vw - 940px) / 2)"
          paddingRight="calc((100vw - 940px) / 2)"
        />
      </Box>
    </Box>
  );
};

export default Umami;
